import script from "./page-export.vue?vue&type=script&setup=true&lang=ts"
export * from "./page-export.vue?vue&type=script&setup=true&lang=ts"

import "./page-export.vue?vue&type=style&index=0&id=67172237&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67172237"]])

export default __exports__